var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.$style.input,attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function (e) { return _vm.$emit('input', e.target.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }